<template>
	<div class="login">
		<div class="img">
			<img src='https://oss.mcloud.moveclub.cn/mpmsalpha/20220324/1648087803-623bd2fb1f93e.png' />
		</div>
		<div class="logintext">登录</div>
		<div class="form">
			<div>
			  <van-field 
				v-model="mobile" 
				label="手机号" 
				type="tel"
				border
				label-width="50px"
				placeholder="请输入手机号" />
			</div>
			<div class="form-item">
			  <van-field 
				v-model="code" 
				label="验证码" 
				label-width="50px"
				type="tel"
				border
				placeholder="请输入验证码" />
				<van-button class="btnBox" :disabled="isdisabled" type="primary" size="normal" @click="sendCode">{{ btnText }}</van-button>
			</div>
			<div>
				<van-button class="btnLogin" type="primary" @click="loginUnions">登录</van-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			timer: '',
			mobile: '',
			code: '',
			btnText: '发送验证码',
			// btnText: '60s后重新发送',
			isdisabled: false,
		}
	},
	mounted() {
		
	},
	destroyed() {
		clearInterval(this.timer)
	},
	methods: {
		sendCode(){
			if(this.mobile == ''){
				this.$toast({
					type: 'fail',
					message: '请填写正确手机号!',
					// duration: 0
				});
				return
			}
			var data = {
				mobile: this.mobile
			}
			console.log("----", data)
			this.$api.unions
				.sendCode(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.isdisabled = true
						var t = 60
						this.timer = setInterval(() =>{
							t = t - 1
							if(t > 0){
								this.btnText = `${t}s后重新发送`
							}else{
								this.isdisabled = false
								this.btnText = `发送验证码`
								clearInterval(this.timer)
							}
							
						}, 1000) 
					}
				})
			
			
		},
		loginUnions(){
			if(this.mobile == ''){
				this.$toast({
					type: 'fail',
					message: '手机号不能为空!',
					// duration: 0
				});
				return
			}
			if(this.code == ''){
				this.$toast({
					type: 'fail',
					message: '验证码不能为空!',
					// duration: 0
				});
				return
			}
			var data = {
				mobile: this.mobile,
				smscode: this.code,
			}
			this.$api.unions
				.mobileLogin(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						localStorage.setItem('mobile', this.mobile)
						this.$router.push({
							name: 'unionshome'
						})
					}
				})
			
			
			
			
			
			
		},
	}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>

